import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const UserLayout = () => {
    return (
        <>
            {
                <div className='layout-wrapper'>
                    {<Sidebar />}
                    <div className='content-wrapper'>
                        {<Header />}
                        <div className='content-page pt-0'>
                            <Outlet />
                        </div>
                    </div>
                </div>
            }
        </>

    )
}

export default UserLayout;